<template>
  <div id="app" :class="language.getLanguage()">
    <router-view />
  </div>
</template>
<script setup lang="ts">
import { onMounted } from 'vue';
import { reportIndexPvUvAndTimeCost, language } from '@tencent/ppd-base-libs';

onMounted(() => {
  reportIndexPvUvAndTimeCost();
});
</script>
<style lang="less">
@import '~@/less/main';
</style>
